import i18next from 'i18next';
import { initReactI18next } from 'react-i18next';
// Import all translation files
import translationEnglish from 'translation/en/common.json';
import translationFrench from 'translation/fr/common.json';
// === TRIMA INTEGRATION ===
import trimaEnglish from 'translation/en/trima.json';
import trimaFrench from 'translation/fr/trima.json';
// === END TRIMA INTEGRATION ===

i18next
  .use(initReactI18next)
  .init({
    debug: false,
    fallbackLng: 'fr',
    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
    },
    resources: {
      en: {
        translation: translationEnglish,
        // === TRIMA INTEGRATION ===
        trima: trimaEnglish,
        // === END TRIMA INTEGRATION ===
      },
      fr: {
        translation: translationFrench,
        // === TRIMA INTEGRATION ===
        trima: trimaFrench,
        // === END TRIMA INTEGRATION ===
      },
    }
  });


export default i18next;
